import { groupBy } from "./fn_general.js"
import { is_equal_set } from "./fn_general.js"

export function make_graph_V(GraphN) {

    // define process
    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    // 0 - initialize empty GraphV
    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////

    let GraphV = {
        info: {
            graph_type: GraphN.info.graph_type,
            n_ranks: GraphN.info.n_ranks,
            n_vertex: 0,
            max_level: GraphN.info.max_level,
            lv_height: 0,
            max_v_in_lv: 0,
            max_y: 0,
            max_x: 0,
            mid_r1x: 0,
            avg_r1x: 0,
            Rx_left: 0,
            Rx_right: 0
        },
        vertex_library: {},
        vertex_levels: [],
        vertex_table: [],
        edge_table: [],
        dict_N_to_V: {},
    }

    // console.log("[FUNCTIONS] tree_vertex : empty GraphV ", GraphV)


    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    // 1 - vertex library
    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////

    let vNumber = 0
    let nodeKeys_in_L = []
    let nodes_in_L = []
    let a_vertex = {}

    let aNode = {}
    let bNode = {}


    for (let i = 0; i < GraphV.info.max_level + 1; i++) {
        //create i-th level
        GraphV.vertex_levels.push([])

        nodeKeys_in_L = GraphN.level_table[i]
        nodes_in_L = nodeKeys_in_L.map(k => { return GraphN.node_library[k] })
            // console.log("nodes_in_L ", nodes_in_L)

        if (nodeKeys_in_L.length == 1) {
            //single node in a level
            a_vertex = convert_N_to_V(i, nodes_in_L, vNumber)

            GraphV.dict_N_to_V[nodeKeys_in_L[0]] = vNumber
            GraphV.vertex_levels[i].push(vNumber)

            GraphV.vertex_library[vNumber] = a_vertex

            vNumber += 1
        } else {
            //grouping nodes in a level
            let group_number = 0
            let equal_topology = true

            for (let n1 = 0; n1 < nodeKeys_in_L.length; n1++) {
                aNode = GraphN.node_library[nodeKeys_in_L[n1]]
                if (n1 == 0) {
                    aNode.g_index = group_number
                }

                //second node
                for (let n2 = n1 + 1; n2 < nodeKeys_in_L.length; n2++) {
                    bNode = GraphN.node_library[nodeKeys_in_L[n2]]
                    equal_topology = is_topological_equal(aNode, bNode)

                    if (equal_topology) {
                        bNode.g_index = aNode.g_index
                    } else {
                        //first - assign g_index
                        if (n1 == 0) {
                            group_number += 1
                            bNode.g_index = group_number
                        }
                    }
                }
            }
            //after creating g_index > grouping by g_index

            const groupBy_g_index = groupBy("g_index")
            let obj_groups = groupBy_g_index(nodes_in_L)
            let obj_keys = Object.keys(obj_groups)
            let aGroup = {}

            for (let g = 0; g < obj_keys.length; g++) {
                aGroup = obj_groups[obj_keys[g]]
                a_vertex = convert_N_to_V(i, aGroup, vNumber)
                aGroup.forEach(v => {
                    GraphV.dict_N_to_V[v.info.doc_key] = vNumber
                })
                GraphV.vertex_levels[i].push(vNumber)
                GraphV.vertex_library[vNumber] = a_vertex
                vNumber += 1
            }
        }
        if (GraphV.vertex_levels[i].length > GraphV.info.max_v_in_lv) {
            GraphV.info.max_v_in_lv = GraphV.vertex_levels[i].length
        }
    }
    //after loop all level
    GraphV.info.n_vertex = vNumber

    // console.log("[FUNCTIONS] tree_vertex : vertex_library ", GraphV)


    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    // 2 - vertex relations
    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////

    let allRelations = ["total", "R", "T", "C", "V"]
    let edge_R = ["R", "T", "C", "V"]
    let aVertex = {}
    let tVertex = {}

    for (let v = 0; v < GraphV.info.n_vertex; v++) {
        aVertex = GraphV.vertex_library[v]

        allRelations.forEach(r => {
            let relation_vins = aVertex.nd_ins[r].map(node => { return GraphV.dict_N_to_V[node] })
            let relation_vouts = aVertex.nd_outs[r].map(node => { return GraphV.dict_N_to_V[node] })
            aVertex.v_ins[r] = [...new Set(relation_vins)]
            aVertex.v_outs[r] = [...new Set(relation_vouts)]
            aVertex.v_din[r] = aVertex.v_ins[r].length
            aVertex.v_dout[r] = aVertex.v_outs[r].length

            if (edge_R.includes(r) && aVertex.v_dout[r] > 0) {
                for (let t = 0; t < aVertex.v_outs[r].length; t++) {
                    tVertex = GraphV.vertex_library[aVertex.v_outs[r][t]]
                    GraphV.edge_table.push({
                        source_id: aVertex.vid,
                        target_id: tVertex.vid,
                        kind: r
                    })
                }
            }
            //!!!!! to do : source and target have too large vertex data
        })
        aVertex.v_outs["ext"] = []
        aVertex.v_outs["cumul"] = []
        aVertex.v_dout["ext"] = 0
        aVertex.v_dout["cumul"] = 0
        aVertex.v_ins["ext"] = []
        aVertex.v_din["ext"] = 0
    }

    // Find v_outs extend & cumulative
    // downward
    // case nLevels
    let tL = GraphV.info.max_level + 1
        // console.log("GraphV.info.max_level -> tL : ", tL)

    // if tL = 1, only project
    // if tL = 2, no outs ext and cumul 
    if (tL < 3) {
        for (let v = 0; v < GraphV.info.n_vertex; v++) {
            let vx = GraphV.vertex_library[v]
            vx.v_dout.ext = vx.v_dout.total
            vx.v_dout.cumul = vx.v_dout.total
            vx.v_outs.ext = vx.v_outs.total
            vx.v_outs.cumul = vx.v_outs.total

            vx.v_din.ext = vx.v_din.total
            vx.v_ins.ext = vx.v_ins.total
        }
    } else {
        for (let nL = 1; nL < tL + 1; nL++) {

            // console.log("FINDING EXTENDED : Lv down ", tL - nL, " / up ", nL - 1)
            // downward for outs
            let VidsInLevel = GraphV.vertex_levels[tL - nL]
                // console.log("Entering tL >= 3 / [downward] level ", tL - nL, VidsInLevel)
            for (let v = 0; v < VidsInLevel.length; v++) {
                // select a vin a Level x
                let vid = VidsInLevel[v]
                let vx = GraphV.vertex_library[vid]
                    // select outs_v of v 
                let outs_total = vx.v_outs.total

                // initialization
                let outs_ext = []
                let outs_cumul = []

                if (vx.v_dout.total > 0) {
                    outs_ext = JSON.parse(JSON.stringify(outs_total))
                    outs_total.forEach(out_vid => {
                        let ov = GraphV.vertex_library[out_vid]
                        if (ov.v_dout.total > 0) {
                            outs_ext.push(...ov.v_outs.total)
                        }
                        outs_cumul.push(out_vid)
                        outs_cumul.push(...ov.v_outs.cumul)
                    })
                }
                vx.v_outs.ext = [...new Set(outs_ext)]
                vx.v_outs.cumul = [...new Set(outs_cumul)]
                vx.v_dout.ext = vx.v_outs.ext.length
                vx.v_dout.cumul = vx.v_outs.cumul.length
                vx.position.xd = 1 + vx.v_dout.cumul
                    // console.log("check v_outs : ", vx.v_outs)
            }

            // upward for ins
            let VUpInLevel = GraphV.vertex_levels[nL - 1]
            for (let vu = 0; vu < VUpInLevel.length; vu++) {
                let vt = VUpInLevel[vu]
                let vux = GraphV.vertex_library[vt]
                let ins_total = vux.v_ins.total
                let ins_ext = []
                if (vux.v_din.total > 0) {
                    ins_ext = JSON.parse(JSON.stringify(ins_total))
                    ins_total.forEach(in_vid => {
                        let iv = GraphV.vertex_library[in_vid]
                        if (iv.v_din.total > 0) {
                            ins_ext.push(...iv.v_ins.total)
                        }
                    })
                }
                vux.v_ins.ext = [...new Set(ins_ext)]
                vux.v_din.ext = vux.v_ins.ext.length

                // error check
                if (vux.v_din.total > vux.v_din.ext) {
                    // console.log("[ERROR] Finding ins.ext ", vux)
                }
                if (vux.v_din.ext == 0) {
                    // console.log("[CHECK] v_ins.ext is ZERO", vux)
                }
            }
        }
        // console.log("[CHECK] v_ins.ext ", GraphV.vertex_library)
    }

    // console.log("[FUNCTIONS] tree_vertex : finalize ", GraphV)
    return GraphV
}

export function convert_N_to_V(level, node_arr, v_number) {

    let check_topology = true

    // // test same topology of nodes
    // if (node_arr.length > 1) {
    //   console.log("n nodes", node_arr.length)
    // }

    let aVertex = {}

    if (check_topology) {
        aVertex = {
            vid: v_number,
            n_nodes: node_arr.length,
            nodes: node_arr.map(v => { return v.info.doc_key }),
            level: level,
            nd_din: node_arr[0].din,
            nd_dout: node_arr[0].dout,
            nd_ins: node_arr[0].ins,
            nd_outs: node_arr[0].outs,
            v_ins: {},
            v_outs: {},
            v_din: {},
            v_dout: {},
            position: { x: 0, y: 0, xd: 1 }
        }
    } else {
        // console.log("[ERROR] convert node to vertex : nodes are not topological equal ", node_arr)
    }
    return aVertex
}

export function is_topological_equal(aNode, bNode) {

    let is_equal = true
    let rTypes = ["R", "C", "T", "V"]

    let same_degree = true
        //degree check
    rTypes.forEach(r => {
        if (aNode.din[r] != bNode.din[r]) { same_degree = false }
        if (aNode.dout[r] != bNode.dout[r]) { same_degree = false }
    })

    //check ins
    let same_ins = true
    if (same_degree) {
        rTypes.forEach(r => {
            if (aNode.din[r] > 0) {
                if (!is_equal_set(aNode.ins[r], bNode.ins[r])) { same_ins = false }
            }
        })
    } else {
        same_ins = false
    }

    //check outs
    if (same_ins) {
        rTypes.forEach(r => {
            if (aNode.dout[r] > 0) {
                //already degree check
                //compare outs[r]
                if (!is_equal_set(aNode.outs[r], bNode.outs[r])) { is_equal = false }
            }
        })
    } else {
        is_equal = false
    }
    return is_equal
}


// WEBPACK FOOTER //
// ./src/custom/tree_vertex.js